import usersTemplate from './users.html';

export default angular
  .module('main.notifications.groups.edit.tabs.users', [])

  .directive('editNotificationGroupUsersTab', () => {
    return {
      restrict: 'E',
      template: usersTemplate,
      scope: {},
      controller: ($scope,
                   $state,
                   $rootScope,
                   $q,
                   $filter,
                   utils,
                   ToastsService,
                   PermissionsService,
                   EditNotificationGroupDataProvider) => {
        const $t = $filter('translate');
        const SELECTED_USER_LOCAL_STORAGE_KEY = 'Selected-User';

        $scope.dataProvider = EditNotificationGroupDataProvider.instance;

        angular.extend($scope, {
          copyToClipboard: $rootScope.copyToClipboard,
          searchUser: searchUser,
          editUser: editUser,
          isUserEditable: isUserEditable,
          isAdminUser: isAdminUser,
          addNotificationUser: addNotificationUser,
          isNotificationUsersListed: isNotificationUsersListed,
          removeNotificationUser: removeNotificationUser,
          removeUserAll: removeUserAll,
          back: back,
        });

        // Remove modals
        $scope.$on('$destroy', () => {
          $('#remove-notification-group-user-dialog').remove();
        });

        init();

        function init() {
          $scope.loading = true;
          $scope.notificationUsersLoading = false;

          $q.all([
            $scope.dataProvider.selectedGroupResource.init(),
            $scope.dataProvider.groupUsersResource.init(),
          ])
            .then(() => {
              initGroupUsers();
              $scope.loading = false;
            }, () => {
              $scope.loading = false;
              $scope.notificationUsersLoading = false;
            });
        }

        function initGroupUsers() {
          $scope.notificationUsers = angular.copy($scope.dataProvider.groupUsersResource.value || []);
          $scope.notificationUsersLoading = false;
        }

        /**
         * Focus on the search users field,
         * and scroll down to that field
         */
        function searchUser() {
          $('#form-search-user').form('clear');
          $('#input-user-email').trigger('focus');
        }

        function isUserEditable(user) {
          return PermissionsService.canIEditUser(user);
        }

        function isAdminUser(user) {
          return !!(user && user.role);
        }

        function editUser(user, $event) {
          utils.setStorageItem(SELECTED_USER_LOCAL_STORAGE_KEY, user);
          if (isUserEditable(user)) {
            $rootScope.$emit('refreshChooseMenuEvent', 'users');
            $state.go('main.users.edit', {
              from: 'notifications',
              fromTab: $scope.dataProvider.activeTab
            });
          } else {
            $rootScope.$emit('refreshChooseMenuEvent', 'users');
            $state.go('main.users.view', {
              from: 'notifications',
              fromTab: $scope.dataProvider.activeTab
            });
          }
        }

        function addNotificationUser(user) {
          return $scope.dataProvider.addNotificationUser(user.id)
            .then(() => {
              initGroupUsers();
              ToastsService.success(null, $t('notifications.messages.userAddedSuccess'));
            })
            .catch(err => handleError(err));
        }

        function isNotificationUsersListed() {
          return !$scope.loading && !$scope.notificationUsersLoading && $scope.notificationUsers && $scope.notificationUsers.length > 0;
        }

        /**
         * Open the remove-user dialog.
         * The dialog's "Remove" action removes the user from the current group;
         * the "Remove from all groups" action removes them from every group.
         * @param {Object} user User to remove
         */
        function removeNotificationUser(user) {
          $scope.selectedUser = user;
          $('#remove-notification-group-user-dialog').modal({
            closable: true,
            detachable: true,
            onApprove: () => removeUser(user, false),
          }).modal('show');
        }

        /**
         * Remove the user from all notification groups in the organization.
         * @param {Object} user User to remove
         * @param {boolean} allGroups Whether to remove from all groups
         */
        function removeUserAll(user, allGroups) {
          return removeUser(user, allGroups);
        }

        /**
         * Perform the removal and refresh the list.
         * @param {Object} user User to remove
         * @param {boolean} allGroups Whether to remove from all groups
         */
        function removeUser(user, allGroups) {
          if (!user) {
            return;
          }
          return $scope.dataProvider.removeNotificationUser(user.id, allGroups)
            .then(() => {
              initGroupUsers();
              $('#remove-notification-group-user-dialog').modal('hide');
              ToastsService.success(null, $t('notifications.messages.userRemovedSuccess'));
            }, (err) => {
              $('#remove-notification-group-user-dialog').modal('hide');
              handleError(err);
            });
        }

        /**
         * Handle error and stop loading
         */
        function handleError(err) {
          $scope.loading = false;
          $scope.notificationUsersLoading = false;
          return utils.handleApiError(err);
        }

        function back() {
          // Navigated from the organization
          if ($state.params.from === 'organization') {
            $state.go('main.organizations.edit', {
              tab: $state.params.fromTab
            });
            return;
          }
          $state.go('main.notifications.groups.list');
        }

      }
    };
  })
  .name;
